/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchWithAuth } from '../helper/makeAjaxRequest';
import { TEMPLATE_URL } from '../constant';

const [PENDING, FULLFILLED, REJECTED] = ['pending', 'fulfilled', 'rejected'];

// selector
export const masterTaskListSelector = (state) => state?.masterTaskList?.data?.task;

// thunk middleware
export const fetchMasterTaskList = createAsyncThunk('fetchMasterTaskList', async (adminCode, { rejectWithValue }) => {
  try {
    const task = await fetchWithAuth(`${TEMPLATE_URL}/admincodes/${adminCode}/tasks`);
    return { task, adminCode };
  } catch (error) {
    return rejectWithValue(error);
  }
});

// The initial state of the master TaskList component
export const initialState = {
  data: [],
  loading: false,
  error: false,
  status: false
};

const materTaskListSlice = createSlice({
  name: 'masterTaskList',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMasterTaskList.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.data = [];
      state.status = PENDING;
    });
    builder.addCase(fetchMasterTaskList.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = FULLFILLED;
    });
    builder.addCase(fetchMasterTaskList.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.status = REJECTED;
    });
  }
});

// action
export const { fetch, fetchSuccess, fetchFailure } = materTaskListSlice.actions;

// reducer
export default materTaskListSlice.reducer;
